<template>
  <img :src="require(`@/assets/images/membership/${memberStatus}.svg`)" :alt="memberStatus" />
</template>

<script>
export default {
  name: 'UtilMembershipStatusIcon',

  props: {
    memberStatus: {
      type: String
    }
  }
}
</script>
